var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var _a;
import { IdPersistence } from "../../../constants/IdPersistence";
import { utilAnimation } from "../../../utils/animation/utilAnimation";
import { IdSoundGroup } from "../../../utils/sound/IdSoundGroup";
import { utilBlog } from "../../../utils/utilBlog";
import { utilPersistence } from "../../../utils/utilPersistence";
import { TypeActionPlayerSettingsInfo } from "./actionPlayerSettingsInfo";
var initial = {
    animationEnabled: utilAnimation.isAnimationEnabled(),
    blogVersion: utilBlog.getVersion(),
    disableInvites: false,
    mobileTrackingId: undefined,
    sound: (_a = {},
        _a[IdSoundGroup.Music] = utilPersistence.getValue(IdPersistence.Settings)[IdSoundGroup.Music],
        _a[IdSoundGroup.Sound] = utilPersistence.getValue(IdPersistence.Settings)[IdSoundGroup.Sound],
        _a[IdSoundGroup.Global] = utilPersistence.getValue(IdPersistence.Settings)[IdSoundGroup.Global],
        _a),
};
export var reducerPlayerSettingsInfo = function (state, action) {
    if (state === void 0) { state = initial; }
    var _a;
    if (action.type === TypeActionPlayerSettingsInfo.Received &&
        action.playerSettingsInfo != undefined) {
        return __assign({}, state, action.playerSettingsInfo);
    }
    else if (action.type === TypeActionPlayerSettingsInfo.ToggleAnimation) {
        return __assign({}, state, { animationEnabled: action.animationEnabled });
    }
    else if (action.type === TypeActionPlayerSettingsInfo.BlogVersionReceived) {
        return __assign({}, state, { blogVersion: action.version });
    }
    else if (action.type === TypeActionPlayerSettingsInfo.SetSound) {
        return __assign({}, state, { sound: __assign({}, state.sound, (_a = {}, _a[action.soundGroup] = action.enabled, _a)) });
    }
    return state;
};



//////////////////
// WEBPACK FOOTER
// ./src/features/info/player-settings/reducerPlayerSettingsInfo.ts
// module id = 2538
// module chunks = 3